import React from 'react';
import DownloadLink from '../DownloadLink';

import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function CompletedActions({ eventItem }) {
  return <div>
    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>} >
      <Link className="btn btn-outline-primary btn-sm" to={`/forms/${eventItem.id}/view`}><i className="fa fa-list-alt"></i></Link>
    </OverlayTrigger>
    &nbsp;
    {eventItem.appointmentType === 'telehealth' && <>
      <OverlayTrigger placement="top" overlay={<Tooltip>Message</Tooltip>} >
        <Link className="btn btn-outline-primary btn-sm" to={`/forms/${eventItem.id}`}><i className="far fa-comments"></i></Link>
      </OverlayTrigger>
      &nbsp;
    </>
    }
    <DownloadLink eventItem={eventItem} small />
  </div>
}